module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_7042.95e3ef35.png";